// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"styles_skeletonCard__lgDTP","shimmer":"styles_shimmer__spr8R"};